import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className=" mt-16">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo e Descrizione */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center mb-4">
              <img 
                src="/images/CinemaItaliaLogo.svg" 
                alt="Cinema Italia" 
                className="h-12 w-auto"
              />
            </Link>
            <p className="text-cinema-dark-charcoal mb-4 max-w-md">
              L'emozione del grande schermo in un ambiente accogliente e moderno.
            </p>
            <div className="mb-4">
              <img 
                src="/images/LOGO_COMUNE.png" 
                alt="Logo Comune di Castenaso" 
                className="h-16 w-auto opacity-80"
              />
            </div>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/cinemacastenaso" className="text-cinema-dark-charcoal hover:text-cinema-light-red transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 50 50">
                  <path d="M40,0H10C4.486,0,0,4.486,0,10v30c0,5.514,4.486,10,10,10h30c5.514,0,10-4.486,10-10V10C50,4.486,45.514,0,40,0z M39,17h-3 c-2.145,0-3,0.504-3,2v3h6l-1,6h-5v20h-7V28h-3v-6h3v-3c0-4.677,1.581-8,7-8c2.902,0,6,1,6,1V17z"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/cinemaitalia.castenaso/" className="text-cinema-dark-charcoal hover:text-cinema-light-red transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Menu Rapido */}
          <div>
            <h3 className="text-cinema-dark-charcoal font-semibold mb-4">Menu Rapido</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-cinema-dark-charcoal hover:text-cinema-light-red transition-colors">Home</Link></li>
            <li><Link to="/programmazione" className="text-cinema-dark-charcoal hover:text-cinema-light-red transition-colors">Programmazione</Link></li>
            <li><Link to="/eventi" className="text-cinema-dark-charcoal hover:text-cinema-light-red transition-colors">Eventi e Rassegne</Link></li>
            </ul>
          </div>

          {/* Contatti */}
          <div>
            <h3 className="text-cinema-dark-charcoal font-semibold mb-4">Contatti</h3>
            <div className="space-y-2 text-cinema-dark-charcoal">
              <p className="flex items-center">
                <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                </svg>
                Via Nasica 38, Castenaso (BO)
              </p>
              <p className="flex items-center">
                <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                <a href="mailto:castenaso.cinema@gmail.com" className="text-cinema-dark-charcoal hover:text-cinema-light-red transition-colors">castenaso.cinema@gmail.com</a>
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-cinema-dark-charcoal mt-8 pt-8 text-center text-cinema-dark-charcoal">
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0 sm:space-x-4">
            <p>&copy; 2025 Cinema Italia. Tutti i diritti riservati.</p>
            <Link to="/privacy-policy" className="hover:text-cinema-light-red transition-colors text-sm">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;